export const RESET = {
    type: "RESET"
}